import { u as f } from "./ZHUQ44XA.CPgwIBVH.js";
import { k as m, j as c, N as i, S as u, g as B, x as l, h as v, z as N } from "./7FZLUSKW.7Pws8uOI.js";
import { useRef as d, useState as g, useEffect as _ } from "react";
var r = "button", R = m(
  function(t) {
    const e = d(null), a = i(e, r), [n, o] = g(
      () => !!a && u({ tagName: a, type: t.type })
    );
    return _(() => {
      e.current && o(u(e.current));
    }, []), t = B(v({
      role: !n && a !== "a" ? "button" : void 0
    }, t), {
      ref: l(e, t.ref)
    }), t = f(t), t;
  }
), x = c(function(t) {
  const e = R(t);
  return N(r, e);
});
export {
  x as B,
  R as u
};
//# sourceMappingURL=JOBHIYEN.DiBKvV5J.js.map
